import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const { login } = useAuth();

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>AWS Developer Portal</h1>
          <p>Manage Security Groups and restore AWS RDS snapshots with ease</p>
        </div>
        
        <div className="login-card">
          <h2>Sign in to your account</h2>
          <p className="login-subtitle">
            Use your AWS Cognito credentials to access the RDS management console
          </p>
          
          <button 
            className="login-button"
            onClick={login}
          >
            Sign in with AWS Cognito
          </button>
          
          <div className="login-info">
            <h3>What you can do:</h3>
            <ul>
              <li>View and filter RDS snapshots</li>
              <li>Restore databases with one click</li>
              <li>Track restored instances</li>
              <li>Manage VPC and security settings</li>
              <li>Add your IP to RDS security groups with custom rules</li>
            </ul>
          </div>
        </div>
        
        <div className="login-footer">
          <p>Developed by <strong>Volodymyr Shynkar</strong> with <span className="aws-footer-heart">♥</span> to AWS</p>

        </div>
      </div>
    </div>
  );
};

export default LoginPage;